import React from "react";
import { useSelector } from "react-redux";
import { func, shape } from "prop-types";
import { Redirect, Route } from "react-router-dom";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = useSelector(({ auth }) => auth.isAuthenticated);
  const renderComponent = (props) => {
    if (isAuthenticated) {
      return <Component {...rest} {...props} />;
    } else {
      return (
        <Redirect
          to={{
            pathname: "/",
            state: {
              from: props.location,
            },
          }}
        />
      );
    }
  };
  return <Route {...rest} render={renderComponent} />;
};

PrivateRoute.propTypes = {
  component: func,
  location: shape({}),
};

export default PrivateRoute;
